import React, {useEffect, useState} from "react";
import compose from './Util';
import Row from '@gqlapp/base/Row';
import Col from '@gqlapp/base/Col';
import Sortable from "@gqlapp/base/Sortable";
import { FieldArray } from "formik";
import onSortStart from '@xem/utils/onSortStart';
import Box from "@mui/material/Box";
import { MapPin } from 'lucide-react';
import Button from "reactstrap/lib/Button";
import autocompleteConfig from "@xem/look/utils/autocompleteConfig";
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import Typography from '@mui/material/Typography';


const renderOption = (props, option) => {
	const { key, ...optionProps } = props;
	return (
		<li style={{  width: '100%', padding: '5px' }} key={key} {...optionProps} suppressHydrationWarning={false}>
			<Row small>
				<Col xs={'auto'} sx={{ width: '22px', wordWrap: 'break-word' }}><MapPin width={'20px'} /></Col>
				<Col item sx={{ width: 'calc(100% - 22px)', wordWrap: 'break-word' }}>
					<Typography variant="body2" sx={{ color: 'text.secondary' }}>
						{option?.description }
					</Typography>
				</Col>
			</Row>
		</li>)
}



export default compose(function Date(props){
	let { id: name, sx, datasource, setFieldValue, items, onSortEnd, onAdd, onRemove } = props || {};
	let { onFocus, onBlur, onInputChange, autocompleteProps } = props || {};

	let tabIndex = 1;
	let columns = [{ dataIndex: 'data', render: ({ index, name, item, handle, props }) => {
			return (<Row none>
				<Col xs={'auto'} className={'d-flex align-items-center'}>{handle}</Col>
				<Col>
					<Field
						{...autocompleteConfig({
							...autocompleteProps,
							tabIndex: tabIndex++, prefix: <MapPin width={'20px'}/>,
							name, value: item, renderOption, setFieldValue,
							placeholder: `page:block.geo.address.placeholder`.t(),

						})}
					/>
				</Col>
				<Col xs={'auto'} style={{ width: '20px'}} className={'d-flex align-items-center'}>
					{(index !== items.length - 1)&&<>
						{(index !== 0) && <Button color={'default'} onClick={onRemove(props, index)}>-</Button>}
						{(index === 0) && <Button color={'default'} onClick={onAdd(props, index)}>+</Button>}
					</>}
				</Col>
			</Row>)
		}}]

	return <Box sx={sx}>

		<FieldArray
			name={`${name}`}
			render={(props)=><>
				<Sortable
					className={'field-list'}
					useDragHandle
					{...{ items, datasource, columns, onSortStart, onSortEnd, props }}
				/>
			</>}
		/>
	</Box>
})